import { pageTypes } from 'common/constants/pageTypes'
import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from '../enums/entityTypeEnum'
import { PageTypeEnum } from '../enums/PageTypeEnum'

const contactUsEntities = [
  EntityTypeEnum.ContactUs,
  EntityTypeEnum.Field,
  EntityTypeEnum.ContactUsField,
  EntityTypeEnum.TextArea,
  EntityTypeEnum.Attachments,
  EntityTypeEnum.Recaptcha,
  EntityTypeEnum.ContactUsRecaptcha,
  EntityTypeEnum.ContactUsButton,
  EntityTypeEnum.Button, // todo remove https://app.shortcut.com/systeme/story/45859/remove-button-usage-after-migrating-to-contactusbutton
]

const websiteEntityTypes = [
  EntityTypeEnum.WebsiteLayoutBody,
  EntityTypeEnum.WebsitePageBody,
  EntityTypeEnum.WebsiteHeader,
  EntityTypeEnum.WebsiteFooter,
  EntityTypeEnum.WebsiteLogo,
  EntityTypeEnum.WebsiteButton,
  EntityTypeEnum.WebsiteLogin,
  EntityTypeEnum.WebsiteLanguageSwitcher,
  EntityTypeEnum.LoginButton,
  EntityTypeEnum.RegistrationButton,
]

const common = [
  EntityTypeEnum.Section,
  EntityTypeEnum.Row,
  EntityTypeEnum.Body,
  EntityTypeEnum.Column,
  EntityTypeEnum.Headline,
  structureTypes.BUTTON,
  structureTypes.FORM_INPUT,
  EntityTypeEnum.Field,
  EntityTypeEnum.Popup,
  EntityTypeEnum.RemotePopupBody,
  EntityTypeEnum.InlineBody,
  EntityTypeEnum.ContentBox,
  EntityTypeEnum.Countdown,
  EntityTypeEnum.Menu,
  EntityTypeEnum.HorizontalLine,
  EntityTypeEnum.TwitterTweetButton,
  EntityTypeEnum.Carousel,
  EntityTypeEnum.CarouselItem,
  EntityTypeEnum.Faq,
  EntityTypeEnum.FaqItem,
  EntityTypeEnum.Text,
  EntityTypeEnum.Image,
  EntityTypeEnum.Survey,
  EntityTypeEnum.Video,
  EntityTypeEnum.FormInput,
  EntityTypeEnum.Audio,
  EntityTypeEnum.OptInRecaptcha,
  EntityTypeEnum.LanguageSwitcher,
  EntityTypeEnum.RawHtml,
  EntityTypeEnum.Checkbox,
  EntityTypeEnum.BulletList,
  EntityTypeEnum.Button,
]

const websiteCommon = [
  EntityTypeEnum.Audio,
  EntityTypeEnum.BulletList,
  structureTypes.BUTTON,
  EntityTypeEnum.Button,
  EntityTypeEnum.Carousel,
  EntityTypeEnum.CarouselItem,
  EntityTypeEnum.Checkbox,
  EntityTypeEnum.Column,
  EntityTypeEnum.ContentBox,
  EntityTypeEnum.Countdown,
  EntityTypeEnum.Faq,
  EntityTypeEnum.FaqItem,
  EntityTypeEnum.Field,
  structureTypes.FORM_INPUT,
  EntityTypeEnum.FormInput,
  EntityTypeEnum.Headline,
  EntityTypeEnum.HorizontalLine,
  EntityTypeEnum.Image,
  EntityTypeEnum.InlineBody,
  EntityTypeEnum.LanguageSwitcher,
  EntityTypeEnum.Menu,
  EntityTypeEnum.OptInRecaptcha,
  EntityTypeEnum.Popup,
  EntityTypeEnum.RawHtml,
  EntityTypeEnum.Row,
  EntityTypeEnum.Section,
  EntityTypeEnum.Survey,
  EntityTypeEnum.Text,
  EntityTypeEnum.TwitterTweetButton,
  EntityTypeEnum.Video,
]

export const getPageTypeEntities = pageType => {
  let additionalEntities = []
  switch (pageType) {
    case pageTypes.offerInner:
    case pageTypes.offerPage:
      additionalEntities = [
        EntityTypeEnum.Coupon,
        EntityTypeEnum.PaymentButton,
        EntityTypeEnum.TwoStepPaymentForm,
        EntityTypeEnum.TwoStepPaymentFormStepOptIn,
        EntityTypeEnum.TwoStepPaymentFormStepPayment,
        EntityTypeEnum.CustomerType,
        EntityTypeEnum.OrderBump,
        EntityTypeEnum.OfferPrice,
        EntityTypeEnum.PaymentMethod,
        EntityTypeEnum.Product,
        EntityTypeEnum.ShippingFees,
        EntityTypeEnum.Agreement,
        EntityTypeEnum.BookingPaidCalendar,
        EntityTypeEnum.Form,
      ]
      break
    case pageTypes.salesPage:
      additionalEntities = [
        EntityTypeEnum.SalesRedirectionButton,
        EntityTypeEnum.Product,
        EntityTypeEnum.ShippingFees,
        EntityTypeEnum.BookingCalendar,
        EntityTypeEnum.Agreement,
        EntityTypeEnum.PriceElement,
        EntityTypeEnum.Form,
      ]
      break
    case pageTypes.offerUpSellPage:
      additionalEntities = [
        EntityTypeEnum.UpsellAgreeButton,
        EntityTypeEnum.UpsellDisagreeButton,
        EntityTypeEnum.OfferPrice,
        EntityTypeEnum.Product,
        EntityTypeEnum.Agreement,
        EntityTypeEnum.BookingPaidCalendar,
        EntityTypeEnum.Form,
      ]
      break
    case PageTypeEnum.OfferInnerThankYouPage:
    case pageTypes.offerThankYouPage:
      additionalEntities = [
        EntityTypeEnum.OrderSummary,
        EntityTypeEnum.Agreement,
        EntityTypeEnum.Form,
      ]
      break
    case pageTypes.customLogin:
      additionalEntities = [
        EntityTypeEnum.CustomLogin,
        EntityTypeEnum.CustomLoginForgotPassword,
      ]
      break
    case pageTypes.webinarRegistration:
      additionalEntities = [
        EntityTypeEnum.WebinarRegistrationDate,
        structureTypes.START_TIMER,
        EntityTypeEnum.Form,
      ]
      break
    case pageTypes.webinarSession:
      additionalEntities = [
        EntityTypeEnum.WebinarSessionVideo,
        EntityTypeEnum.WebinarCallToAction,
        EntityTypeEnum.Form,
      ]
      break
    case pageTypes.webinarThankYou:
      additionalEntities = [
        EntityTypeEnum.WebinarSessionLink,
        EntityTypeEnum.WebinarSessionDateTime,
        EntityTypeEnum.Form,
      ]
      break
    case pageTypes.blogPostLayout:
      additionalEntities = [
        EntityTypeEnum.BlogPostBody,
        EntityTypeEnum.BlogPostContentPlaceholder,
        EntityTypeEnum.Search,
        EntityTypeEnum.BlogPostLayoutBody,
        EntityTypeEnum.BlogContentPlaceholder,
        EntityTypeEnum.Breadcrumbs,
        EntityTypeEnum.BlogPostDate,
        EntityTypeEnum.ContentTable,
        EntityTypeEnum.ContactUs,
        EntityTypeEnum.BlogPostCategories,
        EntityTypeEnum.BlogPostTitle,
        EntityTypeEnum.BlogPostImage,
        EntityTypeEnum.LatestBlogPosts,
        EntityTypeEnum.LatestBlogPostsCarousel,
        ...contactUsEntities,
      ]
      break
    case pageTypes.blogHome:
    case pageTypes.blogPostListing:
    case pageTypes.blogStatic:
    case pageTypes.blogSearch:
      additionalEntities = [
        EntityTypeEnum.BlogPostListing,
        EntityTypeEnum.SearchResults,
        EntityTypeEnum.Search,
        EntityTypeEnum.LatestBlogPosts,
        EntityTypeEnum.BlogContentPlaceholder,
        EntityTypeEnum.BlogPageBody,
        EntityTypeEnum.ContentTable,
        EntityTypeEnum.ContactUs,
        EntityTypeEnum.TextArea,
        EntityTypeEnum.Attachments,
        EntityTypeEnum.Recaptcha,
        EntityTypeEnum.Button,
        EntityTypeEnum.BlogCategoryTitle,
        EntityTypeEnum.BlogCategoryDescription,
        EntityTypeEnum.LatestBlogPostsCarousel,
        EntityTypeEnum.BookingCalendar,
        ...contactUsEntities,
      ]
      break
    case pageTypes.blogPostBody:
      additionalEntities = [
        EntityTypeEnum.ContentTable,
        EntityTypeEnum.BlogPostBody,
        EntityTypeEnum.BlogPostContentPlaceholder,
        EntityTypeEnum.Search,
        EntityTypeEnum.BlogContentPlaceholder,
        EntityTypeEnum.BlogPostLayoutBody,
        EntityTypeEnum.Breadcrumbs,
        EntityTypeEnum.BlogPostDate,
        EntityTypeEnum.BlogPostCategories,
        EntityTypeEnum.BlogPostTitle,
        EntityTypeEnum.BlogPostImage,
        EntityTypeEnum.LatestBlogPosts,
        EntityTypeEnum.LatestBlogPostsCarousel,
        ...contactUsEntities,
      ]
      break
    case pageTypes.blogLayout:
      additionalEntities = [
        EntityTypeEnum.BlogContentPlaceholder,
        EntityTypeEnum.Search,
        ...contactUsEntities,
      ]
      break
    case PageTypeEnum.FunnelContactUs:
      additionalEntities = [
        EntityTypeEnum.ContactUs,
        EntityTypeEnum.Field,
        EntityTypeEnum.ContactUsField,
        EntityTypeEnum.ContactUsButton,
        EntityTypeEnum.TextArea,
        EntityTypeEnum.Attachments,
        EntityTypeEnum.Recaptcha,
        EntityTypeEnum.ContactUsRecaptcha,
        EntityTypeEnum.Button,
        EntityTypeEnum.Form,
      ]
      break
    case PageTypeEnum.Lecture:
      additionalEntities = [
        EntityTypeEnum.ContentTable,
        EntityTypeEnum.TextArea,
        EntityTypeEnum.Button,
      ]
      break
    case PageTypeEnum.Inline:
      additionalEntities = [EntityTypeEnum.BookingCalendar, EntityTypeEnum.Form]
      break
    case PageTypeEnum.Squeeze:
      additionalEntities = [
        EntityTypeEnum.BookingCalendar,
        EntityTypeEnum.BookingCalendarPreview,
        EntityTypeEnum.Form,
      ]
      break
    case PageTypeEnum.Popup:
      additionalEntities = [EntityTypeEnum.BookingCalendar, EntityTypeEnum.Form]
      break
    case PageTypeEnum.WebsiteHome:
    case PageTypeEnum.WebsiteLayout:
    case PageTypeEnum.WebsiteDefault:
    case PageTypeEnum.WebsiteLogin:
      additionalEntities = [
        ...websiteEntityTypes,
        EntityTypeEnum.Form,
        EntityTypeEnum.BookingCalendar,
        EntityTypeEnum.NavigationMenu,
      ]
      return websiteCommon.concat(additionalEntities)
    case PageTypeEnum.WebsiteSearch:
      additionalEntities = [
        ...websiteEntityTypes,
        EntityTypeEnum.Form,
        EntityTypeEnum.BookingCalendar,
        EntityTypeEnum.NavigationMenu,
        EntityTypeEnum.Search,
        EntityTypeEnum.SearchResults,
      ]
      return websiteCommon.concat(additionalEntities)
    case PageTypeEnum.WebsitePricing:
      additionalEntities = [...websiteEntityTypes, EntityTypeEnum.PriceElement]
      return websiteCommon.concat(additionalEntities)
    case PageTypeEnum.BookingCalendarPreview:
      additionalEntities = [EntityTypeEnum.BookingCalendarPreview]
      break
    default:
      additionalEntities = []
  }

  return common.concat(additionalEntities)
}
